import { Badge } from "@/components/ui/badge";
import { useT } from "@/lib/i18n/use-t";
import { useRegionalFormat } from "@/lib/regional-format/context";

import { formatWeightTotal } from "./format-weight-total";
import { T } from "./weight-total-cell.i18n";

type WeightTotalCellProps = {
  total: number;
  /** Null when there is nothing to judge yet: the total is shown without a status. */
  isComplete: boolean | null;
  /** Total above its status, both centred and the complete status spelled out — a grid column. */
  stacked?: boolean;
};

/** A portfolio's weight total, flagged while it is not 100%. */
export function WeightTotalCell({ total, isComplete, stacked = false }: WeightTotalCellProps) {
  const t = useT(T);
  const { formatNumber } = useRegionalFormat();

  const colour = isComplete === null ? "" : isComplete ? "text-success" : "text-destructive";
  const status = isComplete === false ? t.incomplete : isComplete && stacked ? t.complete : null;

  return (
    <div className={stacked ? "flex flex-col items-center gap-1" : "flex items-center gap-2"}>
      <span className={`${colour} ${stacked ? "font-bold" : ""}`}>
        {formatWeightTotal(total, formatNumber)}%
      </span>
      {status && (
        <Badge variant="outline" className="text-xs">
          {status}
        </Badge>
      )}
    </div>
  );
}
